const canUseDOM = () => !!(typeof window !== "undefined" && window.document && window.document.createElement);
const isBrowser = canUseDOM();

export { canUseDOM, isBrowser };
//# sourceMappingURL=dom.es.js.map
